// auth

export const LOG_IN = 'LOG_IN'
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE'

export const LOG_OUT = 'LOG_OUT'
export const LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS'
export const LOG_OUT_FAILURE = 'LOG_OUT_FAILURE'

export const SIGN_UP = 'SIGN_UP'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE'

export const SHOW_SIGN_IN_CONFIRMATION_MODAL = 'SHOW_SIGN_IN_CONFIRMATION_MODAL'
export const SHOW_SIGN_UP_CONFIRMATION_MODAL = 'SHOW_SIGN_UP_CONFIRMATION_MODAL'

export const CONFIRM_SIGNUP = 'CONFIRM_SIGNUP'
export const CONFIRM_SIGNUP_SUCCESS = 'CONFIRM_SIGNUP_SUCCESS'
export const CONFIRM_SIGNUP_FAILURE = 'CONFIRM_SIGNUP_FAILURE'

export const CONFIRM_LOGIN = 'CONFIRM_LOGIN'
export const CONFIRM_LOGIN_SUCCESS = 'CONFIRM_LOGIN_SUCCESS'
export const CONFIRM_LOGIN_FAILURE = 'CONFIRM_LOGIN_FAILURE'

export const RETRIEVE_SESSION = 'RETRIEVE_SESSION'
export const RETRIEVE_SESSION_SUCCESS = 'RETRIEVE_SESSION_SUCCESS'
export const RETRIEVE_SESSION_FAILURE = 'RETRIEVE_SESSION_FAILURE'
export const RETRIEVE_SESSION_USER_DETAILS_SUCCESS = 'RETRIEVE_SESSION_USER_DETAILS_SUCCESS'

// user

export const USER_GET_DETAILS = 'USER_GET_DETAILS'
export const USER_GET_DETAILS_SUCCESS = 'USER_GET_DETAILS_SUCCESS'
export const USER_GET_DETAILS_PARTIAL_SUCCESS = 'USER_GET_DETAILS_PARTIAL_SUCCESS'
export const USER_GET_DETAILS_FAILURE = 'USER_GET_DETAILS_FAILURE'

export const USERS_GET = 'USER_GET'
export const USERS_GET_SUCCESS = 'USER_GET_SUCCESS'
export const USERS_GET_FAILURE = 'USER_GET_FAILURE'

export var USER_ROLES_INITIAL_STATE = {admin:false,dev:false,customer:false,receiver:false};

export const USER_PUT_DETAILS = 'USER_PUT_DETAILS'
export const USER_PUT_DETAILS_SUCCESS = 'USER_PUT_DETAILS_SUCCESS'
export const USER_PUT_DETAILS_FAILURE = 'USER_PUT_DETAILS_FAILURE'
export const USER_APPLICATION = 'USER_APPLICATION'
export const USER_APPLICATION_SUCCESS = 'USER_APPLICATION_SUCCESS'
export const USER_APPLICATION_FAILURE = 'USER_APPLICATION_FAILURE'
export const USER_UPLOAD = 'USER_UPLOAD'
export const USER_UPLOAD_SUCCESS = 'USER_UPLOAD_SUCCESS'
export const USER_UPLOAD_FAILURE = 'USER_UPLOAD_FAILURE'


// location

export const LOCATIONS_GET = 'LOCATIONS_GET'
export const LOCATIONS_GET_SUCCESS = 'LOCATIONS_GET_SUCCESS'
export const LOCATIONS_GET_FAILURE = 'LOCATIONS_GET_FAILURE'
export const LOCATION_POST = 'LOCATION_POST'
export const LOCATION_POST_SUCCESS = 'LOCATION_POST_SUCCESS'
export const LOCATION_POST_FAILURE = 'LOCATION_POST_FAILURE'
export const LOCATION_PUT = 'LOCATION_PUT'
export const LOCATION_PUT_SUCCESS = 'LOCATION_PUT_SUCCESS'
export const LOCATION_PUT_FAILURE = 'LOCATION_PUT_FAILURE'
export const LOCATION_DELETE = 'LOCATION_DELETE'
export const LOCATION_DELETE_SUCCESS = 'LOCATION_DELETE_SUCCESS'
export const LOCATION_DELETE_FAILURE = 'LOCATION_DELETE_FAILURE'

// shipment

export const SHIPMENTS_GET = 'SHIPMENTS_GET'
export const SHIPMENTS_GET_SUCCESS = 'SHIPMENTS_GET_SUCCESS'
export const SHIPMENTS_GET_FAILURE = 'SHIPMENTS_GET_FAILURE'
export const SHIPMENT_POST = 'SHIPMENT_POST'
export const SHIPMENT_POST_SUCCESS = 'SHIPMENT_POST_SUCCESS'
export const SHIPMENT_POST_FAILURE = 'SHIPMENT_POST_FAILURE'
export const SHIPMENT_PUT = 'SHIPMENT_PUT'
export const SHIPMENT_PUT_SUCCESS = 'SHIPMENT_PUT_SUCCESS'
export const SHIPMENT_PUT_FAILURE = 'SHIPMENT_PUT_FAILURE'
export const SHIPMENT_DELETE = 'SHIPMENT_DELETE'
export const SHIPMENT_DELETE_SUCCESS = 'SHIPMENT_DELETE_SUCCESS'
export const SHIPMENT_DELETE_FAILURE = 'SHIPMENT_DELETE_FAILURE'


//  payment

export const PAYMENT_TOKEN_POST = 'PAYMENT_TOKEN_POST'
export const PAYMENT_TOKEN_POST_SUCCESS = 'PAYMENT_TOKEN_POST_SUCCESS'
export const PAYMENT_TOKEN_POST_FAILURE = 'PAYMENT_TOKEN_POST_FAILURE'
export const PAYMENT_SOURCES_GET = 'PAYMENT_SOURCES_GET'
export const PAYMENT_SOURCES_GET_SUCCESS = 'PAYMENT_SOURCES_GET_SUCCESS'
export const PAYMENT_SOURCES_GET_FAILURE = 'PAYMENT_SOURCES_GET_FAILURE'
export const PAYMENT_SOURCE_DELETE = 'PAYMENT_SOURCE_DELETE'
export const PAYMENT_SOURCE_DELETE_SUCCESS = 'PAYMENT_SOURCE_DELETE_SUCCESS'
export const PAYMENT_SOURCE_DELETE_FAILURE = 'PAYMENT_SOURCE_DELETE_FAILURE'
export const PAYMENT_PRICE_GET = 'PAYMENT_PRICE_GET'
export const PAYMENT_PRICE_GET_SUCCESS = 'PAYMENT_PRICE_GET_SUCCESS'
export const PAYMENT_PRICE_GET_FAILURE = 'PAYMENT_PRICE_GET_FAILURE'
export const PAYMENTS_GET = 'PAYMENTS_GET'
export const PAYMENTS_GET_SUCCESS = 'PAYMENTS_GET_SUCCESS'
export const PAYMENTS_GET_FAILURE = 'PAYMENTS_GET_FAILURE'
export const PAYMENTS_GET_STRIPE_LINK = 'PAYMENTS_GET_STRIPE_LINK'
export const PAYMENTS_GET_STRIPE_CONNECT_LINK_SUCCESS = 'PAYMENTS_GET_STRIPE_CONNECT_LINK_SUCCESS'
export const PAYMENTS_GET_STRIPE_LOGIN_LINK_SUCCESS = 'PAYMENTS_GET_STRIPE_LOGIN_LINK_SUCCESS'
export const PAYMENTS_GET_STRIPE_LINK_FAILURE = 'PAYMENTS_GET_STRIPE_LINK_FAILURE'
export const PAYMENTS_GET_TRANSFERS = 'PAYMENTS_GET_TRANSFERS'
export const PAYMENTS_GET_TRANSFERS_SUCCESS = 'PAYMENTS_GET_TRANSFERS_SUCCESS'
export const PAYMENTS_GET_TRANSFERS_FAILURE = 'PAYMENTS_GET_TRANSFERS_FAILURE'
export const PAYMENTS_POST_TRANSFER = 'PAYMENTS_GET_TRANSFER'
export const PAYMENTS_POST_TRANSFER_SUCCESS = 'PAYMENTS_POST_TRANSFER_SUCCESS'
export const PAYMENTS_POST_TRANSFER_FAILURE = 'PAYMENTS_POST_TRANSFER_FAILURE'




// WEBPACK FOOTER //
// ./src/actions/types.js